import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const PUSH_SDK_ROWS = [
  {
    name: "移动推送-android",
    developer: "杭州阿里云智能科技有限公司",
    packageName: "com.alibaba.sdk.android.push",
    purpose: "用于实现消息推送、通知提醒、推送设备识别、消息下发、到达统计和故障排查",
    personalInfo:
      "设备标识信息（Android ID、OAID、IDFA/IDFV）、推送令牌（Push Token）、IP地址、操作系统类型及版本、应用版本号、移动网络信息",
    link: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.434217.0.0.6f663e68ZeueeL",
  },
  {
    name: "OPPO PUSH 客户端SDK",
    developer: "广东欢太科技有限公司",
    packageName: "com.heytap.msp",
    purpose: "用于通过OPPO厂商推送通道向OPPO/OnePlus设备用户下发推送消息",
    personalInfo:
      "设备标识符（Android ID、OAID、IMEI）、运营商信息、网络信息、推送注册ID（Registration ID）",
    link: "https://open.oppomobile.com/new/developmentDoc/info?id=11228",
  },
  {
    name: "vivo推送SDK",
    developer: "维沃移动通信有限公司",
    packageName: "com.vivo.push",
    purpose: "用于通过vivo厂商推送通道向vivo设备用户下发推送消息",
    personalInfo:
      "设备标识符（IMEI、Android ID、vivo Push RegID）、运营商信息、网络信息",
    link: "https://dev.vivo.com.cn/documentCenter/doc/878",
  },
  {
    name: "小米推送",
    developer: "北京小米移动软件有限公司",
    packageName: "com.xiaomi.push",
    purpose: "用于通过小米厂商推送通道向小米/Redmi设备用户下发推送消息",
    personalInfo:
      "设备标识符（OAID、Android ID、小米推送RegID）、运营商信息、网络信息",
    link: "https://dev.mi.com/console/doc/detail?pId=1822",
  },
  {
    name: "性能加速库",
    developer: "华为软件技术有限公司",
    packageName: "com.huawei.hms.stats",
    purpose: "作为华为HMS核心基础库提供设备性能加速能力，并支持华为推送通道正常运行",
    personalInfo: "设备信息（硬件信息、操作系统信息）、性能统计数据",
    link: "https://developer.huawei.com/consumer/cn/doc/development/graphics-Guides/sdk-data-security-0000001050700772",
  },
  {
    name: "荣耀推送SDK",
    developer: "深圳荣耀软件技术有限公司",
    packageName: "com.hihonor.push",
    purpose: "用于通过荣耀厂商推送通道向荣耀设备用户下发推送消息",
    personalInfo: "设备标识符（Android ID、推送令牌）、网络信息、操作系统信息",
    link: "https://developer.honor.com/cn/docs/11002/guides/sdk-data-security",
  },
  {
    name: "魅族推送SDK",
    developer: "珠海星纪魅族信息技术有限公司",
    packageName: "com.meizu.cloud.pushsdk",
    purpose: "用于通过魅族厂商推送通道向魅族设备用户下发推送消息",
    personalInfo: "设备标识符（设备唯一标识、推送令牌）、网络信息、操作系统信息",
    link: "https://open.flyme.cn/docs?id=202",
  },
];

const WECHAT_SDK_ROWS = [
  {
    name: "微信Open SDK",
    developer: "深圳市腾讯计算机系统有限公司",
    packageName: "com.tencent.mm.opensdk",
    purpose: "用于微信账号登录",
    personalInfo:
      "用户主动选择的微信头像、昵称信息；仅Android、HarmonyOS：验证设备是否安装微信APP；仅iOS：调用剪切板权限，实现第三方应用与微信间的数据传输",
    link: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8",
  },
];

function SdkDisclosureList({ rows }) {
  return (
    <div className="push-sdk-disclosure-list">
      {rows.map((sdk) => (
        <section key={sdk.packageName} className="push-sdk-disclosure-item">
          <h4>
            {sdk.name}（{sdk.packageName}）
          </h4>
          <p>开发者：{sdk.developer}</p>
          <p>使用目的：{sdk.purpose}</p>
          <p>收集个人信息范围：{sdk.personalInfo}</p>
          <p>
            SDK隐私政策链接：
            <a
              href={sdk.link}
              target="_blank"
              rel="noreferrer"
              className="policy-link"
            >
              {sdk.link}
            </a>
          </p>
        </section>
      ))}
    </div>
  );
}

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="privacy-policy-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>伴知宠隐私政策</h1>

      <p>更新日期：2026年 6月 3日</p>
      <p>生效日期：2026年 6月 3日</p>

      <p>
        “伴知宠”指知宠派智能科技（杭州）有限公司及其关联方（以下简称“我们”）合法拥有并运营的、标注名称包含“伴知宠”的客户端应用程序、官方网站、智能硬件以及小程序。本政策适用于伴知宠所有产品及服务（包括伴知宠APP、伴知宠官网、伴知宠AI陪伴车、伴知宠AI项圈）。
      </p>
      <p>本政策将帮助您了解以下内容：</p>
      <p>1、我们如何收集和使用您的个人信息</p>
      <p>2、我们如何使用Cookie和同类技术</p>
      <p>3、我们如何与合作方合作及转让、公开披露个人信息</p>
      <p>4、我们如何保护您的个人信息</p>
      <p>5、您的权利</p>
      <p>6、您个人信息的存储</p>
      <p>7、本政策如何更新</p>
      <p>8、如何联系我们</p>

      <p>
        伴知宠（以下或称“我们”）深知个人信息对您的重要性，并将严格遵守法律法规要求，采取相应的安全保护措施来保护您的个人信息。我们希望通过本隐私政策帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
      </p>
      <p>
        在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，
        <strong>特别应重点阅读我们以粗体标识的条款</strong>
        ，确保您充分理解和同意之后再开始使用。
        <strong>您使用或继续使用我们的服务，即意味着同意我们按照本政策处理您的相关信息。</strong>
      </p>
      <p>
        我们以摘要的形式向您直观说明我们如何处理和保护您的个人信息，点击以下链接可查看：
        <Link to="/privacy-policy/summary" className="policy-link">
          《伴知宠隐私政策摘要》
        </Link>
      </p>
      <p>
        <strong>
          如对本隐私政策有任何疑问，您可以通过本隐私政策“如何联系我们”中提供的方式与我们联系。
        </strong>
      </p>

      <h2>一、我们如何收集和使用您的个人信息</h2>
      <p>在您使用我们的产品/服务时，您需要/可以选择授权我们收集和使用个人信息的场景包括：</p>
      <p>
        1、为了向您提供我们产品/服务的基本功能，您需要授权我们收集、使用必要信息的情形，如您拒绝提供前述必要信息，您将无法正常使用我们的的产品/服务；
      </p>
      <p>
        2、为了向您提供我们产品/服务的拓展功能，您可以选择授权我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品/服务的基本功能。
      </p>
      <p>我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：</p>

      <h3>（一）成为伴知宠用户时收集的信息</h3>
      <p>
        <strong>1、注册、登录</strong>
      </p>
      <p>成为我们的注册用户，我们将会给您提供上传、个性化育宠等核心功能服务。您可通过以下方式进行注册、登录：</p>
      <p>
        （1）您可以通过手机号进行注册，需要您提供
        <strong>手机号码和和短信验证码。</strong>
      </p>
      <p>
        （2）我们可能会根据您的授权从第三方处获取您的第三方账号信息，并与您的伴知宠账号进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。
      </p>
      <p>
        目前我们支持
        <strong>微信账号登录</strong>
        。当您主动选择使用微信登录时，我们会接入微信Open SDK，在您发起并完成微信授权后获取您
        <strong>主动授权的微信头像、昵称信息</strong>
        及授权标识，用于换取您在本应用的唯一标识并完成账号绑定与登录。如您不使用微信登录，可改用手机号等其他方式登录，不影响您正常使用我们的服务。涉及的SDK基本信息如下：
      </p>
      <SdkDisclosureList rows={WECHAT_SDK_ROWS} />
      <p>
        上述SDK收集信息的详情，您还可在
        <Link
          to="/privacy-policy/personal-info-sharing-list"
          className="policy-link"
        >
          《个人信息共享清单》
        </Link>
        中查看。
      </p>
      <p>
        （3）基于我们与通信运营商的合作，当您使用伴知宠“一键登录”功能时，经过您的明示同意，运营商会将您的
        <strong>手机号码</strong>
        发送给我们，便于我们为您提供快捷的登录服务。您也可以自主选择手动填写手机号码的方式完成注册或登录。
      </p>
      <p>
        如果您仅需使用浏览、搜索等基本服务，您不需要提供上述信息成为我们的注册用户；如果您需使用伴知宠平台的发布、评论服务，需按照相关法律法规向伴知宠提供真实身份信息，经伴知宠平台核实认证后方可使用。
      </p>
      <p>
        注册成为伴知宠用户后，您可以对个人信息进行完善，操作路径为：【手机端-我的-点击名字或头像】，您可以设置或修改头像、昵称、性别、生日和地区。
        <strong>其中，为了在互动时提供辨识度，您的头像、昵称将公开展示</strong>
        。您选择填写的性别、生日和地区，仅用于记录，不会在其他任何场景中使用或展示。
      </p>
      <p>
        您提供的上述信息，将在您使用本服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。注销账号的操作路径为：【手机端-我的-通用设置-账号与安全-注销账号】。
      </p>

      <h3>（二）使用伴知宠时光云相册功能时收集的信息</h3>
      <p>
        <strong>1、</strong>
        在创建宠物时光云相册时，您可以设置
        <strong>宠物的名字、品种、生日、性别、头像、及您与宠物的关系</strong>
        ，将有助于我们给您提供更好的服务和体验，但如果您不提供以上信息，也不会影响使用本服务的基本功能。我们也提供
        <strong>记录宠物疫苗、驱虫</strong>
        的功能，仅用于记录，不会在其他任何场景中使用或展示，您可以自主选择是否使用。
      </p>
      <p>
        2、使用时光云相册发表记录功能时，您可以把照片视频从本地相册上传至伴知宠云相册，也可以直接使用拍摄功能进行拍照片、拍视频或录音。在您使用上述功能的过程中，我们会请求开启访问和写入相册/摄像头/录音权限，如果您不允许使用这些权限，您将无法进行上传或拍摄。
      </p>
      <p>
        上传的过程中，您可以添加照片视频的位置，我们需要请求开启获取位置权限，如果您不允许使用这个权限，不会影响您上传照片视频。
      </p>
      <p>
        上传的照片、视频、音频，以及对应的文字、评论、点赞会存储在我们的服务器中，您可以随时删除这些信息。上述信息将存储于中华人民共和国境内。
      </p>
      <p>
        3、我们会记录您访问时光云相册的时间和次数，用于在亲友团页面显示。您可以找到【手机端-我的-通用设置-隐私-来访次数和时间】，选择关闭。这不会影响您正常使用伴知宠服务。关闭后，您的访问将不会显示在亲友团页面，同时，您也不会看到其他亲友的访问情况。
      </p>
      <p>
        4、您可以使用自动检测本地相册的功能来批量上传宠物照片视频，在此过程中，
        <strong>我们会检测你的照片视频中是否包含人脸。我们不会收集存储你的人脸信息。</strong>
        在使用该功能前，我们会征求你的同意，如果您拒绝使用上述功能，也不会影响您正常使用伴知宠服务。
      </p>
      <p>
        5、您在空间上传照片时，经您同意后，我们会使用图像算法技术为您推荐符合您照片的标签。您可以通过【手机端-我的-通用设置-隐私-智能标签推荐】自主选择该功能的开启/关闭。
      </p>

      <h3>（三）使用伴知宠AI问答功能时收集的信息</h3>
      <p>
        <strong>1、填写宠物信息</strong>
      </p>
      <p>
        在您首次使用AI问答功能前，我们需要您提供宠物的基本信息，
        <strong>包括宠物的名字、品种、生日、性别、头像及您与宠物的关系</strong>
        。这些信息将用于构建您宠物的专属数字档案，以便我们通过大模型为您提供更精准、个性化的问答服务。如果您不提供上述信息，您仍可浏览通用内容，但无法获得基于您宠物特征的个性化回答。
      </p>
      <p>
        <strong>2、提问与交互</strong>
      </p>
      <p>
        当您使用AI问答功能输入问题（包括文字、语音）时，我们会收集您输入的
        <strong>问题内容</strong>
        以及您可能上传的
        <strong>相关图片</strong>
        （如宠物症状照片等）。语音输入需开启
        <strong>麦克风权限</strong>
        ，图片上传需开启
        <strong>相机或相册权限</strong>
        。若您拒绝提供这些权限，您仍可通过手动输入文字的方式进行提问，但无法使用语音输入或图片上传功能。
      </p>
      <p>
        我们会对您的提问内容进行分析，并结合您宠物的档案信息生成回答。为了持续改进问答质量，我们可能会记录您的
        <strong>对话历史</strong>
        ，但该记录仅用于优化模型效果，不会用于其他用途。您可以通过【手机端-我的-通用设置-隐私-清除对话历史】主动删除您的历史记录。
      </p>
      <p>
        <strong>3、数据处理说明</strong>
      </p>
      <p>
        您提供的宠物信息及提问内容将传输至我们的服务器，并可能由我们委托的第三方大模型服务商进行处理，以生成回答。我们已与相关服务商签署严格的数据保护协议，要求其仅为本服务目的处理数据，且不得用于其他任何用途。所有数据将存储于中华人民共和国境内，您可随时通过注销账号或联系客服的方式要求删除相关信息。
      </p>

      <h3>（四）使用伴知宠智能硬件功能时收集的信息</h3>
      <p>
        1、
        <strong>设备绑定与连接</strong>
      </p>
      <p>
        当您首次使用智能跟随摄像小车（以下简称“智能陪伴车”）时，您需要通过伴知宠APP进行设备绑定。在此过程中，我们会收集您的
        <strong>Wi-Fi网络信息（SSID、密码）</strong>
        以完成设备联网配置，同时需要获取您手机的
        <strong>蓝牙权限</strong>
        用于近场配对。若您拒绝提供这些信息，将无法完成设备绑定与连接。
      </p>
      <p>
        2、
        <strong>远程操控与实时音视频</strong>
      </p>
      <p>
        绑定成功后，您可以通过APP远程操控智能硬件，包括实时查看摄像头画面、双向语音对讲、控制小车移动等。为实现上述功能，我们需要开启您手机的
        <strong>摄像头权限</strong>
        （用于预览画面）、
        <strong>麦克风权限</strong>
        （用于语音对讲）以及
        <strong>存储权限</strong>
        （用于保存录像或截图）。您在使用过程中产生的
        <strong>操控指令</strong>
        （如移动方向、模式切换）及
        <strong>音视频流</strong>
        将传输至我们的服务器，并转发至您的智能陪伴车，以实现实时交互。我们不会在服务器端永久存储音视频流，仅作实时转发，但您主动录制的视频或截图将保存至您的手机相册或云端（若您开启云存储服务）。
      </p>
      <p>
        3、
        <strong>智能跟随与异常检测</strong>
      </p>
      <p>
        智能硬件具备智能跟随和异常检测功能。为实现这些功能，设备会通过内置传感器采集
        <strong>环境信息</strong>
        （如距离、障碍物）及
        <strong>宠物活动状态</strong>
        ，并可能将
        <strong>设备位置信息</strong>
        （基于室内定位或GPS）用于路径规划。异常检测（如宠物长时间未活动、闯入禁区等）会触发警报，此时设备会采集
        <strong>短时视频片段</strong>
        并推送至您的APP。这些信息仅用于为您提供安全监护服务，不会用于其他目的。
      </p>
      <p>
        4、
        <strong>多用户共享</strong>
      </p>
      <p>
        您可以通过APP邀请家人或朋友共同使用同一台智能硬件。共享时，被邀请人的
        <strong>账号信息</strong>
        （如昵称、头像）将显示在设备共享列表中，且共享用户将获得与您相同的操控权限（但无法解绑设备或修改管理员设置）。您可以随时在【手机端-我的-智能硬件-设备共享】中管理共享用户或停止共享。
      </p>
      <p>
        5、
        <strong>权限与设置</strong>
      </p>
      <p>
        上述功能所需的权限（如位置、蓝牙、摄像头、麦克风等）均需您通过手机系统授权。您可以在【手机端-我的-通用设置-隐私-权限管理】中随时关闭已授权的权限，关闭后对应功能可能无法正常使用。例如，关闭位置权限将影响智能跟随的精度，但您仍可手动控制小车。
      </p>
      <p>
        6、
        <strong>数据存储与删除</strong>
      </p>
      <p>
        您的设备绑定信息、操控日志（不含音视频）将存储在中华人民共和国境内的服务器中，用于保障设备正常运行及故障排查。您主动录制的音视频可随时通过APP删除。当您解绑设备或注销账号时，我们将删除所有与您相关的设备数据，但法律法规另有规定的除外。
      </p>

      <h3>（五）为您提供的其他附加服务</h3>
      <p>
        为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用伴知宠的基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：
      </p>
      <p>
        1、
        <strong>基于位置（定位）信息的附加服务</strong>
        ：您可在开启位置（定位）权限后（统称为“定位权限”）在发布空间记录时选择保存所在的地理位置，以便于您标记拍摄照片、视频的位置信息。您也可以在填写收货信息时，通过位置信息来辅助订单收货地址的填写。您在扫描并绑定智能设备时，需要申请定位权限并获取附近的WiFi信息，才能完成设备的绑定。
      </p>
      <p>
        2、
        <strong>基于相机（摄像头）的附加服务</strong>
        ：您可在开启相机（摄像头）权限（统称为“相机权限”）后拍摄照片、视频，在发布时光云相册、更换头像/封面、回答/评论、客服沟通、扫码关注时我们需要访问相机权限。
        <strong>请您知晓，即使您已同意开启相机权限，我们也仅会在您主动进行拍摄照片、录制视频或扫描图像时，才会获取相应的照片和视频信息</strong>
      </p>
      <p>
        3、
        <strong>基于存储（文件和媒体）/相册（照片与音视频、照片图库）的图片/视频访问及上传的附加服务：</strong>
        您可在开启存储（文件和媒体）/相册（照片与音视频、照片图库）权限（统称为“相册权限”）后上传您的照片/图片/视频、保存客户端提供的图片，在时光云相册、更换头像/封面、保存图片、回答/评论、客服沟通时我们需要访问相册权限。
      </p>
      <p>
        4、
        <strong>基于麦克风的语音技术相关附加服务</strong>
        ：您可以在开启麦克风权限后使用麦克风在宝宝空间中发布录音，或者在您拍摄视频的过程中录制您的声音信息，也可以让您在聊天时通过语音录入消息，还可以让您和智能设备进行语音通话。
        <strong>请您知晓，即使您已同意开启该权限，我们也仅会在您主动使用录制功能时才会通过麦克风获取声音信息。</strong>
      </p>
      <p>
        5、
        <strong>基于蓝牙技术的附加服务</strong>
        ：您可以在开启蓝牙权限后，扫描并连接附近的伴知宠智能设备，或者在展示智能设备列表时，获取智能设备的信息。
      </p>
      <p>
        6、
        <strong>基于消息推送功能的附加服务（推送相关）</strong>
        ：为确保本应用处于关闭、后台运行或设备重启后可正常接收到客户端推送的广播信息，本应用可能监听系统开机完成广播并使用必要的自启动能力，用于恢复通知/推送服务状态。上述能力仅在消息推送、通知提醒相关服务场景下使用，是实现功能及服务所必要的；当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会关联启动其他应用，也不会在无关场景下频繁自启动。
        我们通过集成阿里云移动推送 SDK（EMAS Push）实现上述功能。为完成推送设备识别、生成推送令牌、消息下发、到达统计和排障，该 SDK 可能会在初始化、注册推送服务或接收推送时自动读取您的设备标识信息（Android ID、OAID、IDFA/IDFV）、推送令牌、设备型号、系统版本、网络类型及必要的网络信息。上述信息仅用于消息推送服务，不用于广告画像、个性化推荐或其他无关目的。您可以在系统设置中关闭通知权限，关闭后将无法接收消息提醒，但不影响其他非推送功能的正常使用。
      </p>
      <p>
        为提升不同品牌Android设备上的推送到达率，我们还会根据您的设备品牌接入对应厂商推送SDK。相关SDK仅用于消息推送、通知提醒及推送通道保障，不用于广告画像、个性化推荐或其他无关目的。涉及的SDK基本信息如下：
      </p>
      <SdkDisclosureList rows={PUSH_SDK_ROWS} />
      <p>
        您理解并同意，上述附加服务可能需要您在您的设备中开启您的定位、相机、相册、麦克风、蓝牙的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们手机客户端【手机端-我的-通用设置—隐私—系统权限管理】中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。
        <strong>请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用</strong>
        。
      </p>

      <h3>（六）运营与安全保障及服务日志信息</h3>
      <p>
        当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存。例如您的
        <strong>
          搜索查询内容、IP地址、浏览器类型、电信运营商、使用的语言、访问日期和时间、查看照片视频、关注分享信息、发布信息
        </strong>
        等。
      </p>
      <p>
        我们可能使用依法已收集的您的
        <strong>设备信息、身份信息、服务日志信息</strong>
        ，以及我们的关联公司、合作伙伴在取得您授权或依据法律法规可以提供给我们的信息，来综合判断您的账号及交易风险、进行身份验证（包括触发注册或账号登录验证）、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
      </p>
      <p>
        此处提及的“设备信息”包括：
        <strong>
          设备相关信息（包括设备型号、设备名称、操作系统版本、设备设置、设备标识符IDFA/IDFV/VAID/OAID（HarmonyOS端暂不涉及）/Android ID、IP地址、BSSID/SSID、设备环境、本应用运行中进程信息、WIFI列表及其他软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及通过IP地址、WLAN接入点、蓝牙和基站、传感器信息获取的位置信息）、移动网络信息（MCC、MNC）
        </strong>
        。
      </p>

      <h2>二、我们如何使用Cookie和同类技术</h2>
      <p>
        为使您获得更轻松的访问体验，您使用伴知宠产品或服务时，我们可能会通过采用各种技术收集和存储您访问伴知宠服务的相关数据，在您访问或再次访问伴知宠服务时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。
        <strong>这些数据文件可能是Cookie、SessionStorage，LocalStorage</strong>
        （包括但不限于上述三种类型，下称：浏览器本地储蓄），或您的浏览器或关联应用程序提供的其他本地存储。
      </p>
      <p>
        请您理解，我们的某些服务只能通过使用浏览器本地储蓄才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对浏览器本地储蓄的接受程度或者拒绝伴知宠的浏览器本地储蓄，但拒绝伴知宠的浏览器本地储蓄在某些情况下您可能无法使用依赖于浏览器本地储蓄的伴知宠服务的部分功能。
      </p>

      <h2>三、我们如何与合作方合作及转让、公开披露个人信息</h2>
      <h3>（一）数据使用过程中涉及的合作方</h3>
      <p>
        1、
        <strong>基本原则</strong>
      </p>
      <p>我们与合作方合作时，将遵守以下原则：</p>
      <p>
        （1）
        <strong>合法正当与最小必要原则</strong>
        ：数据处理应当具有合法性基础，具有正当的目的，并以实现处理目的最小范围为限。
      </p>
      <p>
        （2）
        <strong>用户知情权与决定权最大化原则</strong>
        ：：数据处理过程中充分尊重用户对其个人信息处理享有的知情权与决定权。
      </p>
      <p>
        （3）
        <strong>安全保障能力最强化原则</strong>
        ：我们将采取必要措施保障所处理个人信息的安全，审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作协议的有关要求。
      </p>
      <p>
        2、
        <strong>合作方的范围</strong>
      </p>
      <p>若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</p>
      <p>
        3、
        <strong>委托处理</strong>
      </p>
      <p>
        我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
      </p>
      <p>
        4、
        <strong>共同处理</strong>
      </p>
      <p>
        对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。
      </p>
      <p>
        5、
        <strong>合作场景</strong>
      </p>
      <p>
        （1）
        <strong>AI问答服务（调用第三方大模型）</strong>
      </p>
      <p>
        为向您提供基于您宠物信息的个性化AI问答功能，我们会将您填写的
        <strong>宠物信息（如宠物的名字、品种、生日、性别、头像）</strong>
        以及您在提问时输入的
        <strong>问题内容、上传的图片、语音数据</strong>
        ，通过加密方式委托给第三方大模型服务商进行处理，以生成回答。该合作方仅能接触到为实现问答功能所必需的信息，且我们已通过协议严格约束其：
      </p>
      <p>A. 不得将您的个人信息用于模型训练、优化或其他任何超出本服务目的的范围；</p>
      <p>B. 必须采取不低于行业标准的安全措施保障数据安全；</p>
      <p>C. 服务结束后立即删除相关数据，法律法规另有规定的除外。</p>
      <p>
        您可以通过【手机端-我的-通用设置-隐私-清除对话历史】主动删除您的历史记录，也可通过注销账号的方式要求我们删除全部相关信息。
      </p>
      <p>
        （2）
        <strong>智能硬件操控功能（嵌入硬件供应商提供的SDK）</strong>
      </p>
      <p>
        为实现对智能跟随摄像小车的远程操控、实时音视频对讲、智能跟随及异常检测等功能，我们的APP中嵌入了硬件供应商提供的SDK。在您使用相关功能时，该SDK可能会收集以下必要信息：
      </p>
      <p>A. 设备信息：如设备型号、固件版本、设备状态（电量、连接状态），用于设备绑定、状态监控及故障排查；</p>
      <p>
        B. 操控指令与音视频流：如您发出的移动指令、模式切换指令、实时画面、语音对讲内容，用于实现远程操控与交互功能；这些音视频流仅作实时转发，我们及硬件供应商均不会在服务器端永久存储，但您主动录制的视频或截图将保存至您的手机相册或云端（若您开启云存储服务）；
      </p>
      <p>
        C. 网络与位置信息：如Wi-Fi信息（SSID、密码）、设备位置（基于室内定位或GPS），用于设备联网、智能跟随路径规划。
      </p>
      <p>我们已对硬件供应商的SDK进行严格的安全检测，并通过合作协议要求其：</p>
      <p>A. 仅为本服务目的处理信息，不得用于任何其他用途；</p>
      <p>B. 采取加密传输、访问控制等安全措施保障数据安全；</p>
      <p>C. 向用户提供清晰的功能说明和权限管理入口。</p>
      <p>
        您可以在【手机端-我的-通用设置-隐私-权限管理】中随时关闭相关权限（如摄像头、麦克风、位置），关闭后对应功能可能无法正常使用。
      </p>
      <p>
        <strong>（3）安全与统计分析</strong>
      </p>
      <p>
        为保障伴知宠产品及/或服务的安全性，分析产品稳定性，我们可能会委托合作方处理必要的设备信息、日志信息（如设备标识、IP地址、操作记录等）。合作方仅能接触到实现上述目的所必需的信息，且不得用于其他任何目的。
      </p>
      <p>
        为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作方的SDK或其他类似的应用程序。我们会对授权合作方获取有关信息的应用程序接口（API）、SDK进行严格的安全检测，并与授权合作方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。授权合作方单独取得您同意的除外。
      </p>
      <p>
        具体合作方清单及SDK详情请见
        <Link
          to="/privacy-policy/personal-info-sharing-list"
          className="policy-link"
        >
          《个人信息共享清单》
        </Link>
      </p>

      <h3>（二）转让</h3>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p>1、在获取单独同意的情况下转让：获得您的单独同意后，我们会向其他方转让您的个人信息；</p>
      <p>
        2、如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
      </p>

      <h3>（三）公开披露</h3>
      <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p>1、基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；</p>
      <p>
        2、
        <strong>
          如果我们确定您出现违反法律法规，或严重违反伴知宠相关协议规则的情况，或为保护我们及我们关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我们已对您采取的措施
        </strong>
        。
      </p>

      <h3>（四）停止运营</h3>
      <p>
        <strong>
          如果我们停止运营产品及/或服务，将及时停止继续收集您的个人信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品及/或服务相关的个人信息进行删除或匿名化处理
        </strong>
      </p>

      <h3>（五）依法豁免征得您的授权同意的情形</h3>
      <p>
        <strong>以下情形中，共享、转让、公开披露您的个人信息无需征得您的授权同意：</strong>
      </p>
      <p>
        <strong>
          1、为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
        </strong>
      </p>
      <p>
        <strong>2、为履行法定职责或者法定义务所必需；</strong>
      </p>
      <p>
        <strong>3、为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</strong>
      </p>
      <p>
        <strong>4、为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</strong>
      </p>
      <p>
        <strong>5、依照《中华人民共和国个人信息保护法》规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</strong>
      </p>
      <p>
        <strong>6、法律法规规定的其他情形。</strong>
      </p>
      <p>
        <strong>
          请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意
        </strong>
      </p>

      <h2>四、我们如何保护您的个人信息</h2>
      <p>
        （一）我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受SSL协议加密保护；我们同时对伴知宠网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。
      </p>
      <p>
        （二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术的维度提升个人信息的安全性。我们已经设置了个人信息保护专职部门，任命了个人信息保护负责人。我们通过培训课程和考试，不断加强员工对于保护个人信息重要性的认识。
      </p>
      <p>
        （三）互联网并非绝对安全的环境，我们强烈建议您在使用我们的服务时，谨慎地考虑是否共享甚至公开个人信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。
      </p>
      <p>
        （四）如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您及其利害关系人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、信函、电话、推送通知方式告知您及其利害关系人，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
      </p>

      <h2>五、您的权利</h2>
      <p>按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
      <p>
        <strong>（一）访问、复制您的个人信息</strong>
      </p>
      <p>
        您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以登录伴知宠手机客户端，进入“我的”，点击头像后查询、更正个人资料及个人账户相关信息，同时您也可以通过【手机端-我的—通用设置—隐私—个人信息浏览与导出】，查询你的个人信息并提交个人信息导出申请。如果您无法通过上述链接访问这些个人信息，您可以随时发送电子邮件至privacy@zhichongpai.com，我们将在15个工作日内回复您的访问请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请发送电子邮件至privacy@zhichongpai.com。
      </p>
      <p>
        <strong>（二）更正您的个人信息</strong>
      </p>
      <p>
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问、复制您的个人信息”中罗列的方式提出更正申请。如果您无法通过上述链接更正这些个人信息，您可以随时发送电子邮件至privacy@zhichongpai.com。我们将在15个工作日内回复您的更正请求。
      </p>
      <p>
        <strong>（三）删除您的个人信息</strong>
      </p>
      <p>
        您可以通过“（一）访问、复制您的个人信息”中列明的方式删除您的部分信息，或申请注销账户删除您的全部信息。您可以通过与客服联系向我们提出删除个人信息的请求。
      </p>
      <p>
        若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
      </p>
      <p>
        <strong>
          当您或我们协助您删除相关信息后，因为适用的法律要求或安全技术原因，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直至备份更新时可以清除这些信息或实现匿名
        </strong>
      </p>
      <p>
        <strong>（四）改变您授权同意的范围</strong>
      </p>
      <p>
        每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或撤回您的授权同意。您可以通过以下方式自行操作：您可以与伴知宠客服联系或改变您的智能移动设备的设置等方式给予或撤回您的授权同意。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </p>
      <p>
        <strong>（五）转移您的个人信息</strong>
      </p>
      <p>
        若您需要将您的个人信息转移至其他平台、企业或组织，您可以通过本隐私政策披露的方式联系我们。我们将对您的请求进行审核，在符合我国网信部门规定的条件下，我们将为您提供转移相应个人信息的途径。
      </p>
      <p>
        <strong>（六）个人信息主体注销账户</strong>
      </p>
      <p>
        您随时可注销此前注册的账户，您可以通过以下方式自行操作：登录伴知宠手机客户端，进入“我的”，点击【通用设置-账号与安全-注销账号】提交账户注销申请，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，在申请注销的七天后删除您的个人信息，法律法规另有规定的除外。
      </p>
      <p>
        <strong>（七）约束信息系统自动决策</strong>
      </p>
      <p>
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
      </p>
      <p>
        <strong>（八）响应您的上述请求</strong>
      </p>
      <p>
        对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过客服联系我们或直接向我们的个人信息保护负责人发起投诉。我们将在15天内做出答复。
      </p>
      <p>
        为保障您的账户安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账户核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。
      </p>
      <p>
        对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的转移请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
      </p>

      <h2>六、您个人信息的存储</h2>
      <p>
        <strong>
          我们在中华人民共和国境内产生或收集的个人信息，存储在中国境内的服务器。除非取得您的单独同意，或为了履行与您订立的合同，或为了遵循法律法规规定的义务，我们不会向境外提供您的任何个人信息
        </strong>
        。
      </p>
      <p>
        我们会采取合理可行的措施，尽力避免收集无关的个人信息。
        <strong>我们只会在达成本政策所述目的所需的必要期限内保留您的个人信息，除非法律有强制的存留要求。</strong>
      </p>
      <p>我们判断个人信息存储期限主要依据以下标准：</p>
      <p>1、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</p>
      <p>2、保证我们为您提供服务的安全和质量；</p>
      <p>3、您是否同意更长的留存期间；</p>
      <p>4、保证我们在可能的诉讼案件中向法院进行举证；</p>
      <p>5、是否存在保留期限的其他特别约定或法律法规规定。</p>
      <p>在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>

      <h2>七、本政策如何更新</h2>
      <p>
        为给您提供更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策，我们会在伴知宠官方主页（pawtellar.com）上公告发布变更通知或其他适当的方式提醒您更新的内容。但未经您明确同意，我们不会限制您按照本政策所享有的权利，用户不同意变更的，不影响用户使用现有功能。
      </p>
      <p>
        对于重大变更，我们还会提供更为显著的通知（包括我们会通过推送消息甚至向您提供弹窗提示）再次向您告知，并根据法律法规的相关要求征得您的同意。
      </p>
      <p>本政策所指的重大变更包括但不限于：</p>
      <p>1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
      <p>2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</p>
      <p>3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p>4、用户个人信息权利及其行使方式发生重大变化；</p>
      <p>5、我们负责处理个人信息保护负责人的联络方式及投诉渠道发生变化；</p>
      <p>6、个人信息保护影响评估报告表明存在对个人权益有重大影响时。</p>
      <p>7、我们还会将本政策的旧版本存档，供您查阅。</p>

      <h2>八、如何联系我们</h2>
      <p>
        我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过以下方式联系我们：
      </p>
      <p>1、“我的”—“通用设置”—“意见反馈”</p>
      <p>2、发送邮件至privacy@zhichongpai.com</p>
      <p>3、邮寄至浙江省杭州市余杭区亲橙parkD6-403-3知宠派法务部</p>
      <p>如果您对本隐私政策或其他个人信息保护的相关事宜有任何疑问、意见或建议，您也可以通过上述任一方式与我们联系。</p>
      <p>我们将尽快审核您提出的问题、意见或建议，并在验证您的用户身份后的十五个工作日内予以回复。</p>
    </div>
  );
}
